webpackJsonp([63],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_RoomStatus__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_RoomStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_RoomStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_UserSelector__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_UserSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_shared_UserSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_UserSelectorList__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_UserSelectorList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_UserSelectorList__);




var loadBuildings = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id) {
		var filterGroups, response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						filterGroups = [];

						if (id) {
							this.filterBySubsidiaryId = this.renderFilter('com_subsidiaries_id', id, 'eq');
							filterGroups.push(this.filterBySubsidiaryId);
						} else {
							this.filterBySubsidiaryId = null;
						}
						this.filterByBuildingId = null;
						this.buildingId = 0;
						_context.next = 6;
						return this.$http.get('building-simple-list', { params: { filter_groups: filterGroups } });

					case 6:
						response = _context.sent;

						this.buildings = response.data;
						this.loadData();

					case 9:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadBuildings(_x) {
		return _ref.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var filterGroups;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						filterGroups = [];

						if (this.filterBySubsidiaryId) {
							filterGroups.push(this.filterBySubsidiaryId);
						}
						if (this.filterByBuildingId) {
							filterGroups.push(this.filterByBuildingId);
						}
						_context2.next = 5;
						return this.$http.get('room-simple-list', { params: { filter_groups: filterGroups } });

					case 5:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function loadData() {
		return _ref2.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






function addToRowsSelected(rooms) {
	if (rooms && rooms.length > 0) {
		var newRooms = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], rooms);
		if (!this.rowsSelected) {
			this.rowsSelected = [];
		}
		this.rowsSelected = newRooms;
	} else {
		if (this.rowsSelected && this.rowsSelected.length > 0) {
			this.rowsSelected = this.rowsSelected.map(function (row) {
				var newRow = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, row);
				newRow.isAdded = true;
				return newRow;
			});
		}
		this.context = 'error';
		this.text = 'Debe seleccionar al menos 1 habitación para agregarla';
		this.snackbar = true;
	}
}

function addUserSelected() {
	if (this.userSelected) {
		var newUser = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.userSelected);
		newUser.isAdded = true;
		if (!this.userAdded) {
			this.userAdded = {};
		}
		this.userAdded = newUser;
	} else {
		this.context = 'error';
		this.text = 'Debe seleccionar 1 mucama para agregarla';
		this.snackbar = true;
	}
}

function created() {
	this.loadSubsidiaries();
	this.loadData();
}

function loadRooms(id) {
	var filterGroups = [];
	this.filterByBuildingId = this.renderFilter('hot_building_id', id, 'eq');
	filterGroups.push(this.filterByBuildingId);
	this.loadData();
}

function onUserSelected(user) {
	this.userSelected = user;
}

function removeThisRow(id) {
	var rowsIndex = this.rowsSelected.map(function (row) {
		var newRowIndex = row.id;
		return newRowIndex;
	});
	var index = rowsIndex.indexOf(id) > -1 ? rowsIndex.indexOf(id) : null;
	if (index || index === 0) {
		this.rowsSelected.splice(index, 1);
	}
}

function updateRowsSelected(item) {
	if (!this.roomsSelected) {
		this.roomsSelected = [];
	}
	if (item.isSelected) {
		this.roomsSelected.push(item);
		this.room = item;
	} else {
		var roomsId = this.roomsSelected.map(function (room) {
			var newRoomId = room.id;
			return newRoomId;
		});
		var index = roomsId.indexOf(item.id) > -1 ? roomsId.indexOf(item.id) : null;
		if (index || index === 0) {
			this.roomsSelected.splice(index, 1);
		}
	}
}

function userRemoved() {
	this.userAdded = null;
}

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		RoomStatus: __WEBPACK_IMPORTED_MODULE_4__components_shared_RoomStatus___default.a,
		UserSelector: __WEBPACK_IMPORTED_MODULE_5__components_shared_UserSelector___default.a,
		UserSelectorList: __WEBPACK_IMPORTED_MODULE_6__components_shared_UserSelectorList___default.a
	},
	created: created,
	methods: {
		addToRowsSelected: addToRowsSelected,
		addUserSelected: addUserSelected,
		loadBuildings: loadBuildings,
		loadData: loadData,
		loadRooms: loadRooms,
		onUserSelected: onUserSelected,
		removeThisRow: removeThisRow,
		updateRowsSelected: updateRowsSelected,
		userRemoved: userRemoved
	},
	mixins: __WEBPACK_IMPORTED_MODULE_3__shared_mixins__["a" /* default */],
	name: 'detail-by-state',
	data: function data() {
		return {
			buildingId: 0,
			buildings: [],
			cleanTypes: [{ id: 1, name: 'Normal', isSelected: 1 }, { id: 2, name: 'Profunda', isSelected: 0 }, { id: 3, name: 'Turn Over', isSelected: 0 }],
			cleanTypeSelected: 1,
			comment: null,
			filterByBuildingId: null,
			filterBySubsidiaryId: null,
			room: null,
			roomsSelected: null,
			rows: [{
				id: 1,
				code: 'OS',
				icon: 'dirty',
				number: '5201',
				clean_state: 1,
				state: 'booking',
				isSelected: false,
				isDisabled: false,
				isAdded: false,
				created_at: '12/04/2017 - 9:00 a.m.',
				flagactive: 1
			}, {
				id: 2,
				code: 'OS',
				icon: 'dirty',
				number: '5202',
				clean_state: 1,
				isSelected: false,
				isDisabled: false,
				isAdded: false,
				created_at: '12/04/2017 - 9:00 a.m.',
				flagactive: 1
			}, {
				id: 3,
				code: 'OS',
				icon: 'dirty',
				number: '5203',
				clean_state: 1,
				isDisabled: false,
				isSelected: false,
				isAdded: false,
				created_at: '12/04/2017 - 9:00 a.m.',
				flagactive: 1
			}, {
				id: 4,
				code: 'OS',
				icon: 'dirty',
				number: '5204',
				clean_state: 1,
				isSelected: false,
				isDisabled: false,
				isAdded: false,
				created_at: '12/04/2017 - 9:00 a.m.',
				flagactive: 1
			}, {
				id: 5,
				code: 'OS',
				icon: 'dirty',
				number: '5205',
				clean_state: 1,
				isSelected: false,
				isDisabled: false,
				isAdded: false,
				created_at: '12/04/2017 - 9:00 a.m.',
				flagactive: 1
			}],
			rowsSelected: null,
			states: [{
				id: 1,
				name: 'Ocupado sucio',
				code: 'OS',
				icon: 'dirty',
				number: '5201',
				state: 'booking'
			}, {
				id: 2,
				name: 'Vacante sucio',
				code: 'VS',
				icon: 'dirty',
				number: '5201'
			}, {
				id: 3,
				name: 'Turn Over',
				code: 'TO',
				icon: 'turnover',
				number: '5201'
			}, {
				id: 4,
				name: 'Mantenimiento',
				code: 'M',
				icon: 'maintenance',
				number: '5201'
			}, {
				id: 5,
				name: 'Limpieza profunda',
				code: 'LP',
				icon: 'cleandeep',
				number: '5201'
			}, {
				id: 6,
				name: 'Ocupado limpio',
				code: 'OL',
				number: '5201'
			}, {
				id: 7,
				name: 'Vacante limpio',
				code: 'VL',
				number: '5201'
			}, {
				id: 8,
				name: 'Fuera de servicio',
				code: 'FS',
				icon: 'outofservice',
				number: '5201'
			}, {
				id: 9,
				name: 'Bloqueado',
				code: 'B',
				icon: 'locked',
				number: '5201'
			}],
			subsidiaryId: 0,
			userAdded: null,
			users: [{
				id: 1,
				name: 'Maria Chiappe',
				image_url: 'https://static.boredpanda.com/blog/wp-content/uploads/2016/01/cute-squirrel-photography-361__700.jpg',
				assignments: '12 habitaciones'
			}, {
				id: 2,
				name: 'Maria Chiappe 2',
				image_url: 'https://static.boredpanda.com/blog/wp-content/uploads/2016/01/cute-squirrel-photography-361__700.jpg',
				assignments: '12 habitaciones'
			}, {
				id: 3,
				name: 'Maria Chiappe 3',
				image_url: 'https://static.boredpanda.com/blog/wp-content/uploads/2016/01/cute-squirrel-photography-361__700.jpg',
				assignments: '12 habitaciones'
			}, {
				id: 4,
				name: 'Maria Chiappe 4',
				image_url: 'https://static.boredpanda.com/blog/wp-content/uploads/2016/01/cute-squirrel-photography-361__700.jpg',
				assignments: '12 habitaciones'
			}],
			userSelected: null,
			// Snackbar
			context: '',
			snackbar: false,
			text: '',
			timeout: 3000
		};
	}
});

/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".padding-responsive[data-v-21a5ee46]{padding-right:4.6%}.select-clean-type[data-v-21a5ee46]{width:238px}.subtitle-right[data-v-21a5ee46]{color:#6f7a83;float:right;font-size:12px;margin-right:9.5px}.wrap-select-rooms[data-v-21a5ee46]{max-width:calc(100% - 249px)}.full-layout-white[data-v-21a5ee46]{background-color:#fff;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.18);box-shadow:0 2px 4px 0 rgba(0,0,0,.18);padding:21px 20px}label.clean-type[data-v-21a5ee46]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:transparent;border:1px solid #979797;border-radius:100px;color:#85939e;cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:12px;height:33px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:19px 13px 9px 0;width:95px}input.input-clean-type:checked+.clean-type[data-v-21a5ee46]{background:#0b6fff;border-color:#0b6fff;color:#fff}textarea[data-v-21a5ee46]{border:1px solid #d8d8d8}.empty-container[data-v-21a5ee46]{min-height:61px}", "", {"version":3,"sources":["/opt/build/repo/src/housekeeping/dashboard/DetailByState.vue"],"names":[],"mappings":"AACA,qCACE,kBAAoB,CACrB,AACD,oCACE,WAAa,CACd,AACD,iCACE,cAAe,AACf,YAAa,AACb,eAAgB,AAChB,kBAAoB,CACrB,AACD,oCACE,4BAA8B,CAC/B,AACD,oCACE,sBAAwB,AACxB,+CAAwD,AAChD,uCAAgD,AACxD,iBAAmB,CACpB,AACD,kCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,uBAAwB,AACxB,yBAA0B,AAC1B,oBAAqB,AACrB,cAAe,AACf,eAAgB,AAChB,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AACrB,eAAgB,AAChB,YAAa,AACb,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,uBAA0B,AAC1B,UAAY,CACb,AACD,4DACE,mBAAoB,AACpB,qBAAsB,AACtB,UAAa,CACd,AACD,0BACE,wBAA0B,CAC3B,AACD,kCACE,eAAiB,CAClB","file":"DetailByState.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.padding-responsive[data-v-21a5ee46] {\n  padding-right: 4.6%;\n}\n.select-clean-type[data-v-21a5ee46] {\n  width: 238px;\n}\n.subtitle-right[data-v-21a5ee46] {\n  color: #6f7a83;\n  float: right;\n  font-size: 12px;\n  margin-right: 9.5px;\n}\n.wrap-select-rooms[data-v-21a5ee46] {\n  max-width: calc(100% - 249px);\n}\n.full-layout-white[data-v-21a5ee46] {\n  background-color: white;\n  -webkit-box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.18);\n          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.18);\n  padding: 21px 20px;\n}\nlabel.clean-type[data-v-21a5ee46] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background: transparent;\n  border: 1px solid #979797;\n  border-radius: 100px;\n  color: #85939e;\n  cursor: pointer;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  font-size: 12px;\n  height: 33px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin: 19px 13px 9px 0px;\n  width: 95px;\n}\ninput.input-clean-type:checked + .clean-type[data-v-21a5ee46] {\n  background: #0b6fff;\n  border-color: #0b6fff;\n  color: white;\n}\ntextarea[data-v-21a5ee46] {\n  border: 1px solid #d8d8d8;\n}\n.empty-container[data-v-21a5ee46] {\n  min-height: 61px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1466:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1381);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("d98e5604", content, true);

/***/ }),

/***/ 1600:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md2": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.subsidiaries,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "label": "Sucursal",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": _vm.loadBuildings
    },
    model: {
      value: (_vm.subsidiaryId),
      callback: function($$v) {
        _vm.subsidiaryId = $$v
      },
      expression: "subsidiaryId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md2": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.buildings,
      "disabled": _vm.buildings.length === 0,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "label": "Edificio",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": _vm.loadRooms
    },
    model: {
      value: (_vm.buildingId),
      callback: function($$v) {
        _vm.buildingId = $$v
      },
      expression: "buildingId"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "mt-3": ""
    }
  }, [_c('div', {
    staticClass: "wrap-select-rooms text-xs-left"
  }, [_c('span', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Seleccione las habitaciones:")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle-right"
  }, [_vm._v("5 habitaciones")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": ""
    }
  }, _vm._l((_vm.rows), function(row) {
    return _c('room-status', {
      key: row.id,
      attrs: {
        "clean-state": row.clean_state,
        "number": row.number,
        "code": row.code,
        "room": row,
        "labelFor": ("room-" + (row.number)),
        "roomId": row.id,
        "extra-state": row.state,
        "size": 'medium',
        "status-icon": row.icon
      },
      on: {
        "on-room-selected": _vm.updateRowsSelected
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "select-clean-type text-xs-left"
  }, [_c('span', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Tipo de limpieza:")]), _vm._v(" "), _c('div', {
    staticClass: "select-slots-housekeeping mt-2"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.states,
      "item-text": "name",
      "item-value": "name",
      "chips": "",
      "max-height": "auto",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_vm._v("\n\t\t\t\t\t\t" + _vm._s(data.item.name) + "\n\t\t\t\t\t\t"), _c('room-status', {
          attrs: {
            "clean-state": data.item.id,
            "number": data.item.number,
            "code": data.item.code,
            "room": data.item,
            "labelFor": ("room-" + (data.item.number)),
            "extra-state": data.item.state,
            "size": 'medium',
            "status-icon": data.item.icon
          }
        })]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [
          [_c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.name)
            }
          })], 1), _vm._v(" "), _c('room-status', {
            attrs: {
              "clean-state": data.item.id,
              "number": data.item.number,
              "code": data.item.code,
              "room": data.item,
              "extra-state": data.item.state,
              "size": 'medium',
              "status-icon": data.item.icon
            }
          })]
        ]
      }
    }]),
    model: {
      value: (_vm.states.filter(function (state) { return state.id === Number(_vm.$route.params.stateId); })[0].name),
      callback: function($$v) {
        _vm.states.filter(function (state) { return state.id === Number(_vm.$route.params.stateId); })[0].name = $$v
      },
      expression: "states.filter(state => state.id === Number($route.params.stateId))[0].name"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        _vm.addToRowsSelected(_vm.roomsSelected)
      }
    }
  }, [_vm._v("\n\t\t\t\tAgregar\n\t\t\t")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "divider-full"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('span', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Asigne a la mucama:")]), _vm._v(" "), _c('user-selector-list', {
    staticClass: "mt-2",
    attrs: {
      "users": _vm.users
    },
    on: {
      "on-change-selected": _vm.onUserSelected
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "text-xs-left": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-add",
    on: {
      "click": _vm.addUserSelected
    }
  }, [_vm._v("\n\t\t\t\tAgregar\n\t\t\t")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "divider-full"
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "full-layout-white",
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    staticClass: "body-border-right",
    attrs: {
      "md6": "",
      "pr-3": "",
      "mb-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Habitaciones:")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "empty-container",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.rowsSelected) ? _c('div', {
    staticClass: "mt-2"
  }, _vm._l((_vm.rowsSelected), function(row) {
    return _c('room-status', {
      key: row.id,
      attrs: {
        "clean-state": row.clean_state,
        "number": row.number,
        "room": _vm.room,
        "code": row.code,
        "isAdded": row.isAdded,
        "labelFor": ("room-" + (row.number)),
        "extra-state": row.state,
        "size": 'medium',
        "status-icon": row.icon,
        "roomId": row.id
      },
      on: {
        "on-room-removed": _vm.removeThisRow
      }
    })
  })) : _vm._e()])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Mucamas:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.userAdded) ? _c('user-selector', {
    staticClass: "mt-2",
    attrs: {
      "user": _vm.userAdded
    },
    on: {
      "on-user-removed": _vm.userRemoved
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "pl-3": ""
    }
  }, [_c('span', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Tipo de limpieza:")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.cleanTypes), function(type) {
    return _c('div', {
      key: type.id
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.cleanTypeSelected),
        expression: "cleanTypeSelected"
      }],
      staticClass: "input-clean-type",
      attrs: {
        "type": "radio",
        "hidden": "",
        "name": "cleanTypes",
        "id": type.id
      },
      domProps: {
        "value": type.id,
        "checked": _vm._q(_vm.cleanTypeSelected, type.id)
      },
      on: {
        "__c": function($event) {
          _vm.cleanTypeSelected = type.id
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "clean-type",
      attrs: {
        "for": type.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(type.name) + "\n\t\t\t\t\t")])])
  })), _vm._v(" "), _c('span', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Comentario o sugerencia:")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "mt-2 mb-3",
    attrs: {
      "name": "assign-comment",
      "cols": "80",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-assign-tasks"
  }, [_vm._v("\n\t\t\t\tAsignar a tareas\n\t\t\t")])], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeout,
      "success": _vm.context === 'success',
      "info": _vm.context === 'info',
      "warning": _vm.context === 'warning',
      "error": _vm.context === 'error',
      "primary": _vm.context === 'primary',
      "secondary": _vm.context === 'secondary',
      "top": "",
      "right": ""
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.text) + "\n\t")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1466)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1345),
  /* template */
  __webpack_require__(1600),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21a5ee46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/63.bbbe43889d704fe23171.js